import React, { useCallback } from 'react';
import { Card, CardBody, CardHeader, CardTitle } from 'reactstrap';
import { PanelHeader } from 'js/components';
import { useNotify } from 'js/hooks/useNotify';
import formatRubricSaveError from './formatRubricSaveError';
import RubricForm from './RubricForm';

const DEFAULT_DOCUMENT = {
  assessment_keys: [],
  question_sets: [],
  excluded_breakout_ids: [],
  meta: {},
};

function CreateRubricComponent({ workspaceId, onSave }) {
  const notify = useNotify();

  const handleSubmit = useCallback(
    async (values) => {
      try {
        await onSave({ name: values.name.trim(), document: DEFAULT_DOCUMENT });
        notify({
          type: 'success',
          message: 'Rubric created.',
        });
      } catch (err) {
        notify({
          type: 'danger',
          message: formatRubricSaveError(err),
        });
      }
    },
    [notify, onSave]
  );

  return (
    <div>
      <PanelHeader size="sm" />
      <div className="content">
        <Card>
          <CardHeader>
            <CardTitle tag="h5">Create a rubric</CardTitle>
          </CardHeader>
          <CardBody>
            <RubricForm
              submitLabel="Create"
              onSubmit={handleSubmit}
              cancelUrl={`/w/${workspaceId}/rubrics`}
              autoFocus
            />
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default CreateRubricComponent;
